<template>
    <div class="admin">
        <div v-if="loader" class="admin__loader">
            <loader></loader>
        </div>
        <div v-else class="admin__dashboard">
            <admin-sidebar :mode="mode" @setMode="setMode"></admin-sidebar>
            <admin-dashboard :mode="mode" :user="user" :preferences="preferences" @getPreferences="getPreferences"></admin-dashboard>
        </div>
    </div>
</template>

<script>
import AdminDashboard from './Dashboard';
import AdminSidebar from './Sidebar';
import Loader from '../Loader/Loader';

export default {
    name: 'admin',
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    components: {
        AdminDashboard,
        AdminSidebar,
        Loader
    },
    data() {
        return {
            mode: 'dashboard',
            loader: true,
            preferences: {}
        }
    },
    methods: {
        getPreferences() {
            const that = this;
            let URL = 'https://HOSTNAME/cgi-bin/mkvn-sci-backend/controller.sci.pl?adminPrefsGet';
            URL = URL.replace("HOSTNAME", location.hostname);

            // GET request user preferences
            fetch(URL, {
                    method: 'GET'
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (json) {
                    // Success handler
                    if (json.result.match(/OK/i)) {
                        // Set preferences
                        that.preferences = json.prefs;

                        // Sort exports
                        if (that.preferences.exports) {
                            that.preferences.exports.sort(function (a, b) {
                                return parseInt(b.yearStart) - parseInt(a.yearStart);
                            });
                        }
                    }

                    // Remove loader
                    that.loader = false;
                })
                .catch(function (error) {
                    // TODO: Implement error handling for getPreferences()
                    console.log(error);

                    // Remove loader
                    that.loader = false;
                })
        },
        setMode(mode) {
            if (mode && mode.match(/(management)|(dashboard)/i)) {
                this.mode = mode;
            }
        }
    },
    created() {
        // Get admin preferences
        this.getPreferences();
    }
}
</script>

<style>
/* ---------------------------------------------------
    DASHBOARD STYLE
----------------------------------------------------- */
#dashboard {
    width: calc(100% - 250px);
    background: url('../../assets/background/admin.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    padding: 1.25rem;
    min-height: 100vh;
    position: absolute;
    top: 0;
    right: 0;
}

#dashboard.active {
    width: 100%;
}

/* ---------------------------------------------------
    SIDEBAR STYLE
----------------------------------------------------- */
#sidebar {
    width: 250px;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 999;
    background: #fff;
    transition: all 0.3s;
    -webkit-box-shadow: 1px 0px 20px rgba(0, 0, 0, 0.08);
    box-shadow: 1px 0px 20px rgba(0, 0, 0, 0.08);
}

#sidebar.active {
    margin-left: -250px;
}

#sidebar .sidebar-header {
    padding: 20px;
    background: #272c33;
    color: #fff;
}

/* ---------------------------------------------------
    MEDIAQUERIES
----------------------------------------------------- */
@media (max-width: 768px) {
    #sidebar {
        margin-left: -250px;
    }

    #sidebar.active {
        margin-left: 0;
    }

    #dashboard {
        width: 100%;
    }

    #dashboard.active {
        width: calc(100% - 250px);
    }

    #sidebarCollapse span {
        display: none;
    }
}
</style>
